export const AirDropData = [
  {
    address: "stake1u8hu06gy3hfhcr700p4h2y4f7gzud0lka2njm5ycv0wzmtcpaqj9z",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 1390526,
    o_pool: "pool1uu65k00dp467qsszmqwl6udwnet3zszgx8n3kmn2aq84sae8ha9",
    o_loyalty: 11835011,
    amount: 1041556281,
    registered: "2024-12-17 12:44:36",
    active_epoch_no: 530,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8hu06gy3hfhcr700p4h2y4f7gzud0lka2njm5ycv0wzmtcpaqj9z",
    payment_address:
      "addr1q94h2gzzu37hftykfae2w7mu58q3l99fj6ryvtlxzhjh3wl0cl5sfrwn0s8u77rtw5f2nus9c6lld6489hgfsc7u9khsvaq04d",
    epochs_delegated: 1,
    Ada_delegated: 1041.556281,
    EKI_Rewards: "6,270.75",
    Rate: 0.166098,
  },
  {
    address: "stake1ux0p7s5qng8ay6d0q4tvrc24ezsszlxgx994cwg7juap3rspn0shc",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 1451829,
    o_pool: "",
    o_loyalty: "",
    amount: 15648387,
    registered: "2024-12-16 19:42:53",
    active_epoch_no: 530,
    holder_detail:
      "http://cexplorer.io/stake/stake1ux0p7s5qng8ay6d0q4tvrc24ezsszlxgx994cwg7juap3rspn0shc",
    payment_address:
      "addr1q8k5ulhsjrja0g2tnrxm277unv8lwq5lusq60dc7l2hkfry7rapgpxs06f567p2kc8s4tj9pq97vsv2ttsu3a9e6rz8qh8xt6d",
    epochs_delegated: 1,
    Ada_delegated: 15.648387,
    EKI_Rewards: "1,253.35",
    Rate: 0.012485,
  },
  {
    address: "stake1uy6wg6j74etsvme0y7ww5aje5830kxm32l684jp84w0dsrqrq70aw",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 1455817,
    o_pool: "",
    o_loyalty: "",
    amount: 21665627,
    registered: "2024-12-16 18:36:25",
    active_epoch_no: 530,
    holder_detail:
      "http://cexplorer.io/stake/stake1uy6wg6j74etsvme0y7ww5aje5830kxm32l684jp84w0dsrqrq70aw",
    payment_address:
      "addr1q8lpf6jxv0ppwf2kncftzmzha2cfjr4h3zntmhweas4te2e5u349atjhqehj7fuuafm9ng0zlvdhz4l50tyz02u7mqxqc75n9a",
    epochs_delegated: 1,
    Ada_delegated: 21.665627,
    EKI_Rewards: "1,282.78",
    Rate: 0.01689,
  },
  {
    address: "stake1u8dpnfj8em6pgu4mrw9rt9mjrngdtyx4pfk0g37kp6elt7gwuk8gr",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 1545684,
    o_pool: "pool1c86ul4pnqvu7jzag8fjdy6dgrn6pt4ad4vmyq038hyg0wl2kaed",
    o_loyalty: 11919168,
    amount: 293861907,
    registered: "2021-08-23 13:17:36",
    active_epoch_no: 529,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8dpnfj8em6pgu4mrw9rt9mjrngdtyx4pfk0g37kp6elt7gwuk8gr",
    payment_address:
      "addr1q8qw6pk4jrzz28lwvalynp7tkp8lg69wxjqjp2m7plxezz76rxny0nh5z3etkxu2xkthy8xs6kgd2znv73ravr4n7huscnu7g3",
    epochs_delegated: 2,
    Ada_delegated: 293.861907,
    EKI_Rewards: "3,790.82",
    Rate: 0.077519,
  },
  {
    address: "stake1u9hrm2rfrevtpml9qw2a09pavdr3fz665dxhdqlcmcw6r7qzvmrh2",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 1556159,
    o_pool: "pool1kks6sgxvx7p6fe3hhnne68xzwa9jg8qgy50yt3w3lrelvns7390",
    o_loyalty: 63308165,
    amount: 4694379402,
    registered: "2022-12-13 21:07:58",
    active_epoch_no: 529,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9hrm2rfrevtpml9qw2a09pavdr3fz665dxhdqlcmcw6r7qzvmrh2",
    payment_address:
      "addr1q9k3acshrldfad8ags89mlww6euxq2kmy05c2zgj90rtnqnw8k5xj8jckrh72qu4672r6c68zj944g6dw6pl3hsa58uqq6azkv",
    epochs_delegated: 2,
    Ada_delegated: 4694.379402,
    EKI_Rewards: "25,312.40",
    Rate: 0.185458,
  },
  {
    address: "stake1u8wpmcav3k2wh5ngajjmd3e3qaq6nesrh4qay654ynch7lgzjpf5l",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 1572296,
    o_pool: "pool1dpu6kslgxlg3ccrwxldl8e6r7ylnq0yalafmucp0yc7k6qegtt0",
    o_loyalty: 1287996,
    amount: 3403591429,
    registered: "2024-11-30 12:28:30",
    active_epoch_no: 529,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8wpmcav3k2wh5ngajjmd3e3qaq6nesrh4qay654ynch7lgzjpf5l",
    payment_address:
      "addr1qy69w80d33vtkhd5nn0z6ra8dmzjedmvmanypmshq9x77pkurh36erv5a0fx3m99kmrnzp6p48nq802p6f4f2f830a7sgncf04",
    epochs_delegated: 2,
    Ada_delegated: 3403.591429,
    EKI_Rewards: "18,999.55",
    Rate: 0.179141,
  },
  {
    address: "stake1u9xjp6r8j332xl6f05tp6djvpqtpf3jpxtkzkwldw85euqq330936",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 1635952,
    o_pool: "",
    o_loyalty: "",
    amount: 354014187,
    registered: "2024-12-14 16:34:10",
    active_epoch_no: 529,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9xjp6r8j332xl6f05tp6djvpqtpf3jpxtkzkwldw85euqq330936",
    payment_address:
      "addr1qx49n39zwlatphvkfppz8efk3sewkglp6dc98r2zj2305zzdyr5x09rz5dl5jlgkr5myczqkznryzvhv9va76u0fncqqhs8as7",
    epochs_delegated: 2,
    Ada_delegated: 354.014187,
    EKI_Rewards: "4,085.01",
    Rate: 0.086662,
  },
  {
    address: "stake1u8nfhmgu0w9g34sf7gtty088pmqrfre6ujq2ylseeyzt6jce9axy8",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 1814831,
    o_pool: "pool1kks6sgxvx7p6fe3hhnne68xzwa9jg8qgy50yt3w3lrelvns7390",
    o_loyalty: 1190080,
    amount: 35838941394,
    registered: "2024-01-31 22:56:18",
    active_epoch_no: 529,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8nfhmgu0w9g34sf7gtty088pmqrfre6ujq2ylseeyzt6jce9axy8",
    payment_address:
      "addr1q8cczcm5qnnwr97xu4c72jh4uwmy2cd6pw4kcddhxrh8qc0xn0k3c7u23rtqnuskkg7wwrkqxj8n4eyq5flpnjgyh49s9aqy6s",
    epochs_delegated: 2,
    Ada_delegated: 35838.94139,
    EKI_Rewards: "177,630.88",
    Rate: 0.201761,
  },
  {
    address: "stake1u98t0h0s0gz7u9jnt2e397jsdstpypfzcvhm8g5y0hgfp6srz7n9e",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 2053497,
    o_pool: "pool1dpu6kslgxlg3ccrwxldl8e6r7ylnq0yalafmucp0yc7k6qegtt0",
    o_loyalty: 9297839,
    amount: 155145322017,
    registered: "2023-04-15 12:52:13",
    active_epoch_no: 528,
    holder_detail:
      "http://cexplorer.io/stake/stake1u98t0h0s0gz7u9jnt2e397jsdstpypfzcvhm8g5y0hgfp6srz7n9e",
    payment_address:
      "addr1q90apk0t6k07fdwmqh04rgj7sgyr9jzxdfjtkkr99ap9pvjwklwlq7s9act9xk4nzta9qmqkzgzj9se0kw3gglwsjr4q8wsrrt",
    epochs_delegated: 3,
    Ada_delegated: 155145.322,
    EKI_Rewards: "762,298.52",
    Rate: 0.203523,
  },
  {
    address: "stake1ux62nw59y7qs9xvxfsl26knff6e7lxwcklcaa7rhxwjjd9sgtl36y",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 2260336,
    o_pool: "pool1jgwu8lq3dqddnnx7prymcgcyrqy0fdlghg33he2hmw9t2gma3zd",
    o_loyalty: 1360371,
    amount: 15047782347,
    registered: "2020-12-15 22:23:18",
    active_epoch_no: 528,
    holder_detail:
      "http://cexplorer.io/stake/stake1ux62nw59y7qs9xvxfsl26knff6e7lxwcklcaa7rhxwjjd9sgtl36y",
    payment_address:
      "addr1qxkypvdmue74jv0q8z5cxzjwvfuaaqsj6vteejq35xh2w7d54xag2fupq2vcvnp744dxjn4na7va3dl3mmu8wva9y6tqz8ll8q",
    epochs_delegated: 3,
    Ada_delegated: 15047.78235,
    EKI_Rewards: "77,124.53",
    Rate: 0.19511,
  },
  {
    address: "stake1ux07khqwphy3jre4jnwp847v6wtaw4qz869rxl6ekavkqjqvt2rfs",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 2309396,
    o_pool: "pool17xh922cr9skc0fqk7sr8at6xx6eluh5qyv9p7ca2x0mtc3st0mz",
    o_loyalty: 24268530,
    amount: 16491180553,
    registered: "2022-01-19 15:49:08",
    active_epoch_no: 528,
    holder_detail:
      "http://cexplorer.io/stake/stake1ux07khqwphy3jre4jnwp847v6wtaw4qz869rxl6ekavkqjqvt2rfs",
    payment_address:
      "addr1q85qy76ecz4723qt2k2fvggfu4wlkrgculujvfxr5f4j6jvladwqurwfry8nt9xuz0tue5uh6a2qy052xdl4nd6evpyqvkr7av",
    epochs_delegated: 3,
    Ada_delegated: 16491.18055,
    EKI_Rewards: "84,183.74",
    Rate: 0.195895,
  },
  {
    address: "stake1u85xqhw7g6njma73uuc423zyqkd7pwx9pc2lcv0rx3req6cczxnad",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 2392577,
    o_pool: "pool1dqhaw0h2f4ehpdhh57quszcj22qhkglhg6yvaf39w3clxdl2kpy",
    o_loyalty: 61667559,
    amount: 3108763931,
    registered: "2021-12-20 05:55:06",
    active_epoch_no: 528,
    holder_detail:
      "http://cexplorer.io/stake/stake1u85xqhw7g6njma73uuc423zyqkd7pwx9pc2lcv0rx3req6cczxnad",
    payment_address:
      "addr1qx3u8nxscrt5nylvudq6y6css3zhc5e6090dl4eka5xvqn8gvpwau3489hmaree324zygpvmuzuv2rs4lsc7xdz8jp4s7a4v4x",
    epochs_delegated: 3,
    Ada_delegated: 3108.763931,
    EKI_Rewards: "18,734.46",
    Rate: 0.165938,
  },
  {
    address: "stake1ux4q5fssr2xmtcp5w2wa4mph378en3jvf6sr7zu64l9nlwg4jygsq",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 2739287,
    o_pool: "pool1j742gcsul7u8c05rsqmkgpkvj5qadj0pew69nctu6crqy9wjjn4",
    o_loyalty: 63245292,
    amount: 10012734176,
    registered: "2022-11-30 21:57:03",
    active_epoch_no: 527,
    holder_detail:
      "http://cexplorer.io/stake/stake1ux4q5fssr2xmtcp5w2wa4mph378en3jvf6sr7zu64l9nlwg4jygsq",
    payment_address:
      "addr1q88zfe3m6mts76cstpp2uzzs8ejhvdhyqhnev0vk0d8vg5a2pgnpqx5dkhsrgu5amtkr0ru0n8rycn4q8u9e4t7t87us6l3knp",
    epochs_delegated: 4,
    Ada_delegated: 10012.73418,
    EKI_Rewards: "53,676.47",
    Rate: 0.186539,
  },
  {
    address: "stake1u8e280caeh78me0jucp2fsg99ag23f8al6u3vj6wfwa52jcn0ymrm",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 2758265,
    o_pool: "",
    o_loyalty: "",
    amount: 907888540,
    registered: "2024-12-01 16:48:57",
    active_epoch_no: 527,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8e280caeh78me0jucp2fsg99ag23f8al6u3vj6wfwa52jcn0ymrm",
    payment_address:
      "addr1q8tk46xsnhdfyhts64r8quz6c25my32l8q8y8yxmdh0z4nlj5wl3mn0u0hjl9esz5nqs2t6s4zj0ml4eze95ujamg49spregkj",
    epochs_delegated: 4,
    Ada_delegated: 907.88854,
    EKI_Rewards: "9,147.47",
    Rate: 0.09925,
  },
  {
    address: "stake1uyuq4nmn5knza6pvmgjd8wx3d38p0kadlm5dhe96nunmwagxrmvel",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 3187869,
    o_pool: "",
    o_loyalty: "",
    amount: 15487063,
    registered: "2024-11-26 17:28:53",
    active_epoch_no: 526,
    holder_detail:
      "http://cexplorer.io/stake/stake1uyuq4nmn5knza6pvmgjd8wx3d38p0kadlm5dhe96nunmwagxrmvel",
    payment_address:
      "addr1q9m7ltsuz8fzcfmjs93f3gw4mqeprgyx59a27plrugw8p7ecpt8h8fdx9m5zek3y6wudzmzwzld6mlhgm0jt48e8ka6s375y2u",
    epochs_delegated: 5,
    Ada_delegated: 15.487063,
    EKI_Rewards: "5,959.83",
    Rate: 0.002599,
  },
  {
    address: "stake1uywtmktr28m4ly92dlrdt59xavvh4lw6l320s77xaq5vfwcvcdncw",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 3953324,
    o_pool: "pool1a2gt2mvuf5zvtqlvw2xgks2efze3p4r985ft62q64lua7gx7lal",
    o_loyalty: 83241477,
    amount: 22172467,
    registered: "2024-11-17 20:51:18",
    active_epoch_no: 524,
    holder_detail:
      "http://cexplorer.io/stake/stake1uywtmktr28m4ly92dlrdt59xavvh4lw6l320s77xaq5vfwcvcdncw",
    payment_address:
      "addr1q9x9wjqk79hwx5hesuvaj32cgs39xtjnhdlzsez0cmpx4gquhhvkx50ht7g25m7x6hg2d6ce0t7a4lz5lpaud6pgcjase9pl5r",
    epochs_delegated: 7,
    Ada_delegated: 22.172467,
    EKI_Rewards: "8,346.16",
    Rate: 0.002657,
  },
  {
    "#": 18,
    address: "stake1u9dd2qt2jvdmxvrz8tfc6wtdlrkxqky9enljgnu7y5ukcxqq4khay",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 4079619,
    o_pool: "pool1dmnyhw9uthknzcq4q6pwdc4vtfxz5zzrvd9eg432u60lzl959tw",
    o_loyalty: 83886,
    amount: 210060180517,
    registered: "2021-09-17 08:44:05",
    active_epoch_no: 524,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9dd2qt2jvdmxvrz8tfc6wtdlrkxqky9enljgnu7y5ukcxqq4khay",
    payment_address:
      "addr1q8k9zyjf9xk7yneknymxnqfkcflyn3fc0t42u3qrdqu5cm6665qk4ycmkvcxywkn35ukm78vvpvgtn8ly38euffedsvq26wd20",
    epochs_delegated: 7,
    Ada_delegated: 210060.1805,
    EKI_Rewards: "1,035,577.47",
    Rate: 0.202844,
  },
  {
    address: "stake1uxfa85z4ln5pky4a0v0tls75csk9mf5hw5txcltx6r29wkgxesujv",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 4308253,
    o_pool: "pool1ea34czsr90yc63fmv4gj4tetp7ds7c4jhpj6vqg4yw40wvygdl3",
    o_loyalty: 87736622,
    amount: 45772330,
    registered: "2022-02-02 06:16:40",
    active_epoch_no: 523,
    holder_detail:
      "http://cexplorer.io/stake/stake1uxfa85z4ln5pky4a0v0tls75csk9mf5hw5txcltx6r29wkgxesujv",
    payment_address:
      "addr1q9zm0mtp2s9s8mm000gguqzuxqgc7nf6tryls4n43yntnmvn60g9tl8grvft67c7hlpaf3pvtknfwagkd37kd5x52avsuyckvv",
    epochs_delegated: 8,
    Ada_delegated: 45.77233,
    EKI_Rewards: "9,638.39",
    Rate: 0.004749,
  },
  {
    address: "stake1uy0dktej3mu474frxa7equc5m8w86kxd9tqktz6zdxegqzs9qd2py",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 4383703,
    o_pool: "pool1h6q8jj55dn6727yydlypu0rz4sflf2enxhs0thqydmddgu3shl5",
    o_loyalty: 29920821,
    amount: 325503252693,
    registered: "2023-12-02 13:57:58",
    active_epoch_no: 523,
    holder_detail:
      "http://cexplorer.io/stake/stake1uy0dktej3mu474frxa7equc5m8w86kxd9tqktz6zdxegqzs9qd2py",
    payment_address:
      "addr1qyc2e0f4l7hz0a0ekzd69u4xf0mygxhw3jhfjee9njpnu2q7mvhn9rheta2jxdmajpe3fkwu04vv62kpvk95y6djsq9qpfm2a7",
    epochs_delegated: 8,
    Ada_delegated: 325503.2527,
    EKI_Rewards: "1,601,350.86",
    Rate: 0.203268,
  },
  {
    address: "stake1u94yr4vemf6yh260m00km6l45zcz7f4epnnca2uyypyhnyg9l7frs",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 5238399,
    o_pool: "",
    o_loyalty: "",
    amount: 314893033,
    registered: "2024-11-02 23:53:23",
    active_epoch_no: 521,
    holder_detail:
      "http://cexplorer.io/stake/stake1u94yr4vemf6yh260m00km6l45zcz7f4epnnca2uyypyhnyg9l7frs",
    payment_address:
      "addr1qx3c8rdkrmfxvjz2gn0yc2hf0xf6gchh334p7rnfyd0gkhr2g82enkn5fw45lk7ldh4ltg9s9untjr88364cggzf0xgsud9ck8",
    epochs_delegated: 10,
    Ada_delegated: 314.893033,
    EKI_Rewards: "13,308.21",
    Rate: 0.023662,
  },
  {
    address: "stake1uyuqna5flx9yt7wp6hsp3ug8vws63rsncedftu35ah5pfwcn7wten",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 7905106,
    o_pool: "pool1yl46tklt9df02cf653fv74x2klucj3fc6mhm05n3enpk7lgxfjv",
    o_loyalty: 37637037,
    amount: 505153499,
    registered: "2022-08-13 03:08:34",
    active_epoch_no: 515,
    holder_detail:
      "http://cexplorer.io/stake/stake1uyuqna5flx9yt7wp6hsp3ug8vws63rsncedftu35ah5pfwcn7wten",
    payment_address:
      "addr1qxfzz9fq6fd7qpr5c723p9pua9ungjn5942aq05urs2a7z3cp8mgn7v2ghuur40qrrcswcap4z8p83j6jherfm0gzjascrxl02",
    epochs_delegated: 16,
    Ada_delegated: 505.153499,
    EKI_Rewards: "21,299.62",
    Rate: 0.023717,
  },
  {
    address: "stake1u8wy9ws7mcsurcs0gfl6snzp9yew38fcw4na9yger7ckgeqplkyfa",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 9181299,
    o_pool: "",
    o_loyalty: "",
    amount: 294385974,
    registered: "2024-09-18 08:38:23",
    active_epoch_no: 512,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8wy9ws7mcsurcs0gfl6snzp9yew38fcw4na9yger7ckgeqplkyfa",
    payment_address:
      "addr1q9rt8km4jzwku7wreq2dwdf2cm6rfs5sv4e93ttemput2ckug2apah3pc83q7snl4pxyz2fjazwnsat862g3j8a3v3jqpduky7",
    epochs_delegated: 19,
    Ada_delegated: 294.385974,
    EKI_Rewards: "23,799.27",
    Rate: 0.01237,
  },
  {
    address: "stake1uyk5tcjdwjgfgh822awp0erhs7lczcqewu9xhpscn5re05srcdsc7",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 10455057,
    o_pool: "pool14cq4fchmmqjygwjw4zexmqqd6a7caxptjnvseyu6wanjuppv4vk",
    o_loyalty: 798982,
    amount: 3852434878,
    registered: "2024-07-21 07:57:21",
    active_epoch_no: 509,
    holder_detail:
      "http://cexplorer.io/stake/stake1uyk5tcjdwjgfgh822awp0erhs7lczcqewu9xhpscn5re05srcdsc7",
    payment_address:
      "addr1q9ppa5y3s4r4z6rtpjyc8c2g8t6kcfgk8zd7u6vem698tufdgh3y6aysj3ww546uzlj80pals9spjac2dwrp38g8jlfq7unz8e",
    epochs_delegated: 22,
    Ada_delegated: 3852.434878,
    EKI_Rewards: "44,731.04",
    Rate: 0.086124,
  },
  {
    address: "stake1u9vqfz7kp75tpscyc8smu8a950d9ctv2d35jx6flvc44j5s053n6a",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 10513478,
    o_pool: "pool1pxw4z2m0lmw422hr32dwyy3uz9436g8p7qdmg2sl2w0m5pyk3yn",
    o_loyalty: 10214123,
    amount: 40016952051,
    registered: "2023-03-26 23:07:37",
    active_epoch_no: 509,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9vqfz7kp75tpscyc8smu8a950d9ctv2d35jx6flvc44j5s053n6a",
    payment_address:
      "addr1qxxm70w5vc6k7xdgzh7sfmsjsshlx3480pw0e8f8ukj3806cqj9avragkrpsfs0phc06tg76tskc5mrfyd5n7e3tt9fqh4w0aw",
    epochs_delegated: 22,
    Ada_delegated: 40016.95205,
    EKI_Rewards: "221,600.58",
    Rate: 0.180581,
  },
  {
    address: "stake1ux8levesyxvxptzj0ght2rvaqfnr0skkkhyar9yhsud984srykysl",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 10557099,
    o_pool: "",
    o_loyalty: "",
    amount: 42702743,
    registered: "2024-09-02 10:28:23",
    active_epoch_no: 509,
    holder_detail:
      "http://cexplorer.io/stake/stake1ux8levesyxvxptzj0ght2rvaqfnr0skkkhyar9yhsud984srykysl",
    payment_address:
      "addr1q9g90znmrvyrjnlqze3rw0suu6nc22wz2xutelqgvg8uz8y0ljenqgvcvzk9y73wk5xe6qnxxlpdddwf6x2f0pc620tqhr7ylg",
    epochs_delegated: 22,
    Ada_delegated: 42.702743,
    EKI_Rewards: "26,098.81",
    Rate: 0.001636,
  },
  {
    address: "stake1u9v66twutnusec0fvm50nldesx7c56a9eqkfhrth7qc0vus3svgl3",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 10621280,
    o_pool: "pool1dqhaw0h2f4ehpdhh57quszcj22qhkglhg6yvaf39w3clxdl2kpy",
    o_loyalty: 67737448,
    amount: 128216811,
    registered: "2022-07-10 16:41:14",
    active_epoch_no: 508,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9v66twutnusec0fvm50nldesx7c56a9eqkfhrth7qc0vus3svgl3",
    payment_address:
      "addr1q8g5tq7mn6nma6d48mq9g85gw9lczwd454p88rhqs3csfj2e45kach8epns7jehgl87mnqda3f46tjpvnwxh0ups7eeqdy7uhh",
    epochs_delegated: 23,
    Ada_delegated: 128.216811,
    EKI_Rewards: "27,693.85",
    Rate: 0.00463,
  },
  {
    address: "stake1u9c8qq69wrqwxv9s6028uhsg4k754g7zjx0ywcnpcg3648ccj6kqr",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 10632651,
    o_pool: "",
    o_loyalty: "",
    amount: 43317511,
    registered: "2024-09-01 13:29:11",
    active_epoch_no: 508,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9c8qq69wrqwxv9s6028uhsg4k754g7zjx0ywcnpcg3648ccj6kqr",
    payment_address:
      "addr1qyafa5xhhcj4jqwhel2czrg7r3fywxhw58cc0jx3q3cuj5rswqp52uxquvctp5750e0q3tdaf23u9yv7ga3xrs3r420sh5lr26",
    epochs_delegated: 23,
    Ada_delegated: 43.317511,
    EKI_Rewards: "27,278.64",
    Rate: 0.001588,
  },
  {
    address: "stake1uya5emuplm42jnl4k4axxexpn7p2tss3z0vzuxfvm3pxa4s3fgy6a",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 11137591,
    o_pool: "pool1dmnyhw9uthknzcq4q6pwdc4vtfxz5zzrvd9eg432u60lzl959tw",
    o_loyalty: 40696716,
    amount: 9543473148,
    registered: "2021-12-27 01:56:29",
    active_epoch_no: 507,
    holder_detail:
      "http://cexplorer.io/stake/stake1uya5emuplm42jnl4k4axxexpn7p2tss3z0vzuxfvm3pxa4s3fgy6a",
    payment_address:
      "addr1qylw5vsjz8yrjqaaptjqqga4l4327ejvdd7xp9ptevn2gmpmfnhcrlh2498ltdt6vdjvr8uz5hppzy7c9cvjehzzdmtqh2sdll",
    epochs_delegated: 24,
    Ada_delegated: 9543.473148,
    EKI_Rewards: "74,917.79",
    Rate: 0.127386,
  },
  {
    address: "stake1u883gz5955uyrszhq84hrmzh4aahm7c2dqqyk4cszkj53dghqx252",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 11222457,
    o_pool: "pool1mscll7kd2y9c56kv7thv7kv99wjvrr72uwpmuhphaltjz0pkuqa",
    o_loyalty: 40344105,
    amount: 1851371131,
    registered: "2020-07-30 03:44:51",
    active_epoch_no: 507,
    holder_detail:
      "http://cexplorer.io/stake/stake1u883gz5955uyrszhq84hrmzh4aahm7c2dqqyk4cszkj53dghqx252",
    payment_address:
      "addr1q8n8ngwfynryal3e84w0kwpchlmjq9rhevpl8j6wzt4j24x0zs9gtffcg8q9wq0tw8k90tmm0has56qqfdt3q9d9fz6s0c8a2y",
    epochs_delegated: 24,
    Ada_delegated: 1851.371131,
    EKI_Rewards: "37,298.09",
    Rate: 0.049637,
  },
  {
    address: "stake1u960qt2qd4lu5nfu2nn43v8k8gp239drwtl6x5wsvl5vgzc3u92yk",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 12162631,
    o_pool: "pool1mscll7kd2y9c56kv7thv7kv99wjvrr72uwpmuhphaltjz0pkuqa",
    o_loyalty: 3152281,
    amount: 191800498643,
    registered: "2021-12-20 21:18:37",
    active_epoch_no: 505,
    holder_detail:
      "http://cexplorer.io/stake/stake1u960qt2qd4lu5nfu2nn43v8k8gp239drwtl6x5wsvl5vgzc3u92yk",
    payment_address:
      "addr1q989u5smkhuzamp062cggtz27h903x6p5r5m8u8vt79chyn57qk5qmtlefxnc488tzc0vwsz4z26xuhl5dgaqelgcs9s49ky4h",
    epochs_delegated: 26,
    Ada_delegated: 191800.4986,
    EKI_Rewards: "968,634.50",
    Rate: 0.198011,
  },
  {
    address: "stake1u8ula5lhezr5mg5j622mjahn7wuyr4k7jpzlzn06uxwr2fcnp2vg9",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 12331818,
    o_pool: "pool15k0zeppza4qzgf6z7wmwsgvl5rz9f6489zxhrxqa8dj6jzju6ct",
    o_loyalty: 28792898,
    amount: 1802491909,
    registered: "2024-08-12 21:29:44",
    active_epoch_no: 504,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8ula5lhezr5mg5j622mjahn7wuyr4k7jpzlzn06uxwr2fcnp2vg9",
    payment_address:
      "addr1q8f2tcxjqgzkp42cp68py3px543er0225f4c9wddpz42qc0elmfl0jy8fk3f9554h9m08uacg8tdayz979xl4cvux5nsh5flgn",
    epochs_delegated: 27,
    Ada_delegated: 1802.491909,
    EKI_Rewards: "40,589.48",
    Rate: 0.044408,
  },
  {
    address: "stake1u9prpdd7sg4vj2y53yyn2caytkdnqx2rlyw47qwdc59tumq64tnym",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 12733775,
    o_pool: "pool15fxktqvd92sq8plh3rjdrksumt9p8rzsayfk4akv2hng5r8ukha",
    o_loyalty: 834961,
    amount: 797569053,
    registered: "2023-02-25 08:35:29",
    active_epoch_no: 504,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9prpdd7sg4vj2y53yyn2caytkdnqx2rlyw47qwdc59tumq64tnym",
    payment_address:
      "addr1qy7unnxuteldrkp8nzy68u67xn5gvquqke037gcf9j0qjsjzxz6maq32ey5ffzgfx436ghvmxqv587gatuqum3g2hekq5eh5ff",
    epochs_delegated: 27,
    Ada_delegated: 797.569053,
    EKI_Rewards: "35,674.72",
    Rate: 0.022357,
  },
  {
    address: "stake1u8vjqcvxa9hd5sm3j3hhl4cctv9mpyt0hcvzdmzfxxwezysyhx9ez",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 13209204,
    o_pool: "pool1j742gcsul7u8c05rsqmkgpkvj5qadj0pew69nctu6crqy9wjjn4",
    o_loyalty: 54434076,
    amount: 239395339,
    registered: "2022-02-06 19:16:18",
    active_epoch_no: 502,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8vjqcvxa9hd5sm3j3hhl4cctv9mpyt0hcvzdmzfxxwezysyhx9ez",
    payment_address:
      "addr1qxjat6h65r0q5n74usj26q8vrk39qnaddseynutrsm42stkeypscd6twmfphr9r00lt3skctkzgkl0scymkyjvvajyfqkujhdg",
    epochs_delegated: 29,
    Ada_delegated: 239.395339,
    EKI_Rewards: "35,298.49",
    Rate: 0.006782,
  },
  {
    address: "stake1uyyxfwr5yu5v4w666m4wqa7lrjgxmdjwhle7eywvekkxuxs6u57ku",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 13305032,
    o_pool: "pool1pqm2cev326p2mrruzw9xru65uvt3r7f0rdf5gtx54zdskxqhmur",
    o_loyalty: 7878483,
    amount: 1062900805,
    registered: "2021-12-20 02:34:33",
    active_epoch_no: 502,
    holder_detail:
      "http://cexplorer.io/stake/stake1uyyxfwr5yu5v4w666m4wqa7lrjgxmdjwhle7eywvekkxuxs6u57ku",
    payment_address:
      "addr1qyjuwtyq43mm4ms0pzjxx3agsa2jv76sgnjqmda6c7clsssgvju8gfege2a444h2upma78ysdkmya0lnajguendvdcdq445r9j",
    epochs_delegated: 29,
    Ada_delegated: 1062.900805,
    EKI_Rewards: "39,326.01",
    Rate: 0.027028,
  },
  {
    address: "stake1u8509p0zvrem0ufurkw2tdzygxhf54laq6gl3uc45m4zwhcwxhwns",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 13449455,
    o_pool: "pool15fxktqvd92sq8plh3rjdrksumt9p8rzsayfk4akv2hng5r8ukha",
    o_loyalty: 188275,
    amount: 1849912769,
    registered: "2024-07-28 18:44:32",
    active_epoch_no: 502,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8509p0zvrem0ufurkw2tdzygxhf54laq6gl3uc45m4zwhcwxhwns",
    payment_address:
      "addr1q94ckudkfc5pzfxacuh0fnmvja5mkujaeg0ztz5ce2nvw4hg72z7yc8nklcnc8vu5k6ygsdwnftl6p53lre3tfh2ya0shqyfd2",
    epochs_delegated: 29,
    Ada_delegated: 1849.912769,
    EKI_Rewards: "43,175.04",
    Rate: 0.042847,
  },
  {
    address: "stake1u9klwlf3csh6skj4thak44yyd680yrw20d55qlu7egn39tcc60xdg",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 13564824,
    o_pool: "",
    o_loyalty: "",
    amount: 25088470359,
    registered: "2024-07-29 14:59:38",
    active_epoch_no: 502,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9klwlf3csh6skj4thak44yyd680yrw20d55qlu7egn39tcc60xdg",
    payment_address:
      "addr1q8zzfj9w4w24w4p59xmu42xd79thn8nj7a70hyfzmv3g8ftd7a7nr3p04pd92h0mdt2ggm5w7gxu57mfgpleaj38z2hsyksu2a",
    epochs_delegated: 29,
    Ada_delegated: 25088.47036,
    EKI_Rewards: "156,827.68",
    Rate: 0.159975,
  },
  {
    address: "stake1uyfy2l2teyqtng4s72zmlq3uy969ctr6zeu2953ct642usg0saz8v",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 13607074,
    o_pool: "pool1uqgn8wt3qwaextmmurmcjmk3egwsac6sunyqtrssrdeavlgpyr4",
    o_loyalty: 80001926,
    amount: 21752909,
    registered: "2024-07-29 03:15:28",
    active_epoch_no: 502,
    holder_detail:
      "http://cexplorer.io/stake/stake1uyfy2l2teyqtng4s72zmlq3uy969ctr6zeu2953ct642usg0saz8v",
    payment_address:
      "addr1q8j0f4t4l607l0cqadvdz8ksqwamvmqpj25phsaxezr4jpcjg475hjgqhx3tpu59h7prcgt5tsk859nc5tfrsh424eqs8wx5a5",
    epochs_delegated: 29,
    Ada_delegated: 21.752909,
    EKI_Rewards: "34,234.07",
    Rate: 0.000635,
  },
  {
    address: "stake1uxyhxyj5sju9ltju2k73xjpr72hq5cyxzxu7e5k89m4gtxglmawed",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 13622581,
    o_pool: "pool1a2gt2mvuf5zvtqlvw2xgks2efze3p4r985ft62q64lua7gx7lal",
    o_loyalty: 65942136,
    amount: 1273780233,
    registered: "2022-06-26 17:41:25",
    active_epoch_no: 502,
    holder_detail:
      "http://cexplorer.io/stake/stake1uxyhxyj5sju9ltju2k73xjpr72hq5cyxzxu7e5k89m4gtxglmawed",
    payment_address:
      "addr1qym7z772tsckn8gv2fj3avzem6c578s7p22dcch3kd6npmvfwvf9fp9ct7h9c4dazdyz8u4wpfsgvydeanfvwth2skvs0n2axj",
    epochs_delegated: 29,
    Ada_delegated: 1273.780233,
    EKI_Rewards: "40,357.35",
    Rate: 0.031563,
  },
  {
    address: "stake1uxlxfksw6ut6u7vx6uzy95w7pmrjsraj29pdqmlqdd5hnvsgdglw0",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 13626066,
    o_pool: "pool1qku2yhky7sv4dfjfv42uyvauhehuqevk25aw952d7ulzqzx3jcu",
    o_loyalty: 31240797,
    amount: 11277660037,
    registered: "2022-03-06 22:06:03",
    active_epoch_no: 502,
    holder_detail:
      "http://cexplorer.io/stake/stake1uxlxfksw6ut6u7vx6uzy95w7pmrjsraj29pdqmlqdd5hnvsgdglw0",
    payment_address:
      "addr1qyhvwj6m6nkvem6qsg7xn5j66fv2vksspqg07ph43ryqxg47vndqa4ch4eucd4cygtgaurk89q8my52z6ph7q6mf0xeqsecm46",
    epochs_delegated: 29,
    Ada_delegated: 11277.66004,
    EKI_Rewards: "89,283.25",
    Rate: 0.126313,
  },
  {
    address: "stake1u8xc2vfxgcs7cqupqqhhxt8ec7kxxn6ed848ej60smvmuzqvz6e25",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 13639545,
    o_pool: "",
    o_loyalty: "",
    amount: 216407206,
    registered: "2024-07-28 18:14:17",
    active_epoch_no: 501,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8xc2vfxgcs7cqupqqhhxt8ec7kxxn6ed848ej60smvmuzqvz6e25",
    payment_address:
      "addr1qx08x4hgm5jueuuekcrwa9jrquqv8r9wsfw6du4566gsk0xds5cjv33paspczqp0wvk0n3avvd84j6020n95lpkehcyqa0rndc",
    epochs_delegated: 30,
    Ada_delegated: 216.407206,
    EKI_Rewards: "36,362.88",
    Rate: 0.005951,
  },
  {
    address: "stake1uysetnj3pj62grsngvmxqvpsn2m25vhxvy57cv335u6wxgccvxnz3",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 14591190,
    o_pool: "pool13hxlxd6qa68fmfhrvvmasa0mjg30tj9p5v2lmgmgsmrp2rgzkfp",
    o_loyalty: 18404479,
    amount: 1599666413,
    registered: "2022-03-26 20:44:17",
    active_epoch_no: 499,
    holder_detail:
      "http://cexplorer.io/stake/stake1uysetnj3pj62grsngvmxqvpsn2m25vhxvy57cv335u6wxgccvxnz3",
    payment_address:
      "addr1q8eugksktfrw4c3nmg9ycmtxpwsawk986hp2k7y9wgk83rppjh89zr955s8pxsekvqcrpx4k4gewvcffaserrfe5uv3spvvjj4",
    epochs_delegated: 32,
    Ada_delegated: 1599.666413,
    EKI_Rewards: "45,481.61",
    Rate: 0.035172,
  },
  {
    address: "stake1u8cyf7y6sdz3qxm45zl52zktqhjwndq3pue4hy8vn3k2whc9fryh5",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 14717475,
    o_pool: "",
    o_loyalty: "",
    amount: 1576455548,
    registered: "2024-07-16 06:48:47",
    active_epoch_no: 499,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8cyf7y6sdz3qxm45zl52zktqhjwndq3pue4hy8vn3k2whc9fryh5",
    payment_address:
      "addr1qx8k2pusdrd7rwefrfdkwqa04kfycrkdwh8t6qqsaqw5sdhsgnuf4q69zqdhtg9lg59vkp0yax6pzrentwgwe8rv5a0s7yt8h0",
    epochs_delegated: 32,
    Ada_delegated: 1576.455548,
    EKI_Rewards: "45,368.09",
    Rate: 0.034748,
  },
  {
    address: "stake1u8wfswp4xpq7hpv532p7vcvgpvw360mdqvpwjf43uld780gxsfz26",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 15123085,
    o_pool: "",
    o_loyalty: "",
    amount: 19081941,
    registered: "2024-07-11 14:08:37",
    active_epoch_no: 498,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8wfswp4xpq7hpv532p7vcvgpvw360mdqvpwjf43uld780gxsfz26",
    payment_address:
      "addr1qylprgjanmkm0x4pz7w96dh9la7epryr25zkrjqx50aqpz7unqur2vzpawzefz5ruescszcar5lk6qczayntre7muw7supvwgq",
    epochs_delegated: 33,
    Ada_delegated: 19.081941,
    EKI_Rewards: "38,928.28",
    Rate: 0.00049,
  },
  {
    address: "stake1u8aq7kc7kf502kxj85npunz9zsvs8la6vqkeceg3pw9n4lqjqvh6c",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 17349913,
    o_pool: "",
    o_loyalty: "",
    amount: 17300779806,
    registered: "2024-06-15 19:34:49",
    active_epoch_no: 493,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8aq7kc7kf502kxj85npunz9zsvs8la6vqkeceg3pw9n4lqjqvh6c",
    payment_address:
      "addr1qxy37pqmua6ksaxfegrnawagh5x0fel3gtwlzxunxyuw64l6pad3avng74vdy0fxrexy29qeq0lm5cpdn3j3zzut8t7qphk4nv",
    epochs_delegated: 38,
    Ada_delegated: 17300.77981,
    EKI_Rewards: "129,331.83",
    Rate: 0.13377,
  },
  {
    address: "stake1uxfscws4rqhmd33tmv66zmak0efv3gmjw7klucq0lgyl5fgkauss9",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 19681927,
    o_pool: "pool1qs6h0y7czzt605kptmrv6cr85kxd6tajr2hs0etvxphv7tr7nqu",
    o_loyalty: 14276642,
    amount: 12081456914,
    registered: "2023-12-06 14:03:53",
    active_epoch_no: 487,
    holder_detail:
      "http://cexplorer.io/stake/stake1uxfscws4rqhmd33tmv66zmak0efv3gmjw7klucq0lgyl5fgkauss9",
    payment_address:
      "addr1q90qv9j0zf0nc5ghfza68dm8tkgqda2l3v9acpfhc3rl2h5npsap2xp0kmrzhke459hmvljjez3hyaadlesql7sflgjs5r6njv",
    epochs_delegated: 44,
    Ada_delegated: 12081.45691,
    EKI_Rewards: "110,866.63",
    Rate: 0.108973,
  },
  {
    address: "stake1uy822kqzfxg5gqu7g6su6uxyphmp7af7kae28ve2l9yu5jqlkzu3n",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 28165548,
    o_pool: "",
    o_loyalty: "",
    amount: 19443503458,
    registered: "2024-02-11 15:14:14",
    active_epoch_no: 468,
    holder_detail:
      "http://cexplorer.io/stake/stake1uy822kqzfxg5gqu7g6su6uxyphmp7af7kae28ve2l9yu5jqlkzu3n",
    payment_address:
      "addr1qyv5uj8kfwvvj942c8nlmn7sznwjhdgjvfva4phd7xq848qw54vqyjv3gspeu34pe4cvgr0kra6nadmj5wej472fefyqzv7mu9",
    epochs_delegated: 63,
    Ada_delegated: 19443.50346,
    EKI_Rewards: "169,231.65",
    Rate: 0.114893,
  },
  {
    address: "stake1uywrgd42uele5xnn25ycf0pa5mgz39adv6yx64dclmk3kgq2z3kqd",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 28228532,
    o_pool: "",
    o_loyalty: "",
    amount: 195043151,
    registered: "2024-02-10 21:44:30",
    active_epoch_no: 468,
    holder_detail:
      "http://cexplorer.io/stake/stake1uywrgd42uele5xnn25ycf0pa5mgz39adv6yx64dclmk3kgq2z3kqd",
    payment_address:
      "addr1qyv6qr7e6ur9vkyfgcs354em52ryxsucaa0vr0kzwe092dquxsm24enlngd8x4gfsj7rmfks9zt66e5gd42m3lhdrvsqaj6dv0",
    epochs_delegated: 63,
    Ada_delegated: 195.043151,
    EKI_Rewards: "75,093.35",
    Rate: 0.002597,
  },
  {
    address: "stake1u8ll2k0thdrfq7eh3ghln3tv4werlydq07hgcz7g0ljgf3q3sy0x2",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 28750361,
    o_pool: "pool1yl46tklt9df02cf653fv74x2klucj3fc6mhm05n3enpk7lgxfjv",
    o_loyalty: 16414197,
    amount: 16858575,
    registered: "2024-02-04 20:47:21",
    active_epoch_no: 466,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8ll2k0thdrfq7eh3ghln3tv4werlydq07hgcz7g0ljgf3q3sy0x2",
    payment_address:
      "addr1q9nnwzkmug73277vraydajl2gkvapvqdp006vlqw3508m3ll74v7hw6xjpan0z30l8zke2aj87g6qlaw3s9usllysnzqvh6e4q",
    epochs_delegated: 65,
    Ada_delegated: 16.858575,
    EKI_Rewards: "76,575.54",
    Rate: 0.00022,
  },
  {
    address: "stake1u8flj6270hutp43xyh05q05x4rp0l6vjgwwr6l902dr7ysc0s4lap",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 38792425,
    o_pool: "pool1phc0dedrry2jp2s2tqngcw87vzx3mychvm7qqe3470etzsf3ph7",
    o_loyalty: 14413744,
    amount: 163526714,
    registered: "2023-03-24 06:34:13",
    active_epoch_no: 443,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8flj6270hutp43xyh05q05x4rp0l6vjgwwr6l902dr7ysc0s4lap",
    payment_address:
      "addr1q9wt2ywhgeffuek0knkqqpdnfcg8sevmz7mwl24ec300lkknl954ul0ckrtzvfwlgqlgd2xzll5eysuu84727568ufpsv0scjn",
    epochs_delegated: 88,
    Ada_delegated: 163.526714,
    EKI_Rewards: "104,359.63",
    Rate: 0.001567,
  },
  {
    address: "stake1uyyz9l746sn80tfcnwu2lp3lms3w6wkssdlcgrq9f75esfs05jufy",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 40711940,
    o_pool: "pool17e4rdh59t4fmn4g3p02xvs853katrjzge830tsmd3sfdc645yvt",
    o_loyalty: 2475897,
    amount: 479445579,
    registered: "2023-01-05 12:50:52",
    active_epoch_no: 439,
    holder_detail:
      "http://cexplorer.io/stake/stake1uyyz9l746sn80tfcnwu2lp3lms3w6wkssdlcgrq9f75esfs05jufy",
    payment_address:
      "addr1q8tn9et86a8x9e5hdy67fahf2ya4sc5t7h5w7a33rnm9kasgytlat4pxw7kn3xac47rrlhpza5adpqmlssxq2nafnqnqzcaxsa",
    epochs_delegated: 92,
    Ada_delegated: 479.445579,
    EKI_Rewards: "110,611.96",
    Rate: 0.004334,
  },
  {
    address: "stake1u8et4zlw6pahxslveuapzptqe4nwu6h7h80wsrn5h7kz27qs5c657",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 41424377,
    o_pool: "pool1yr0cv3dtmhcfgqa6yetvmf769ngk89e6tepecmjrmjl2jzcw2lm",
    o_loyalty: 38485338,
    amount: 14784661164,
    registered: "2021-10-21 01:51:59",
    active_epoch_no: 437,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8et4zlw6pahxslveuapzptqe4nwu6h7h80wsrn5h7kz27qs5c657",
    payment_address:
      "addr1qx6kyh0kwqtr055ssw4afvafla9w3cesdeucrm408s8cerljh297a5rmwdp7ene6zyzkpntxae40aww7aq88f0avy4uq445dy0",
    epochs_delegated: 94,
    Ada_delegated: 14784.66116,
    EKI_Rewards: "182,928.00",
    Rate: 0.080822,
  },
  {
    address: "stake1u9hcdd4u4zw638kmgpehgraem96u0648uax6gs9hsx6m79skmk302",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 50981209,
    o_pool: "",
    o_loyalty: "",
    amount: 14879202,
    registered: "2023-05-23 13:33:13",
    active_epoch_no: 415,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9hcdd4u4zw638kmgpehgraem96u0648uax6gs9hsx6m79skmk302",
    payment_address:
      "addr1q8vhuwfgwa0ak55pq5tpqlyrmwe7rmq6zx29c40z7nzh0mn0s6mte2ya4z0dksrnws8mnkt4cl420e6d53qt0qd4hutqdh7493",
    epochs_delegated: 116,
    Ada_delegated: 14.879202,
    EKI_Rewards: "136,583.51",
    Rate: 0.000109,
  },
  {
    address: "stake1u89f40yj4awteug4acsmrhmjvzdkc9fnnedk9gqsclhskpg7a5kxr",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 52931793,
    o_pool: "",
    o_loyalty: "",
    amount: 30363192970,
    registered: "2022-04-11 16:16:54",
    active_epoch_no: 332,
    holder_detail:
      "http://cexplorer.io/stake/stake1u89f40yj4awteug4acsmrhmjvzdkc9fnnedk9gqsclhskpg7a5kxr",
    payment_address:
      "addr1q9azhtepld4jalt8dcnuvmxta2tr92jsrm3mjqazmd5eph72n27f9t6uhnc3tm3pk80hycymds2n88jmv2spp3l0pvzssftz0x",
    epochs_delegated: 199,
    Ada_delegated: 30363.19297,
    EKI_Rewards: "382,683.57",
    Rate: 0.079343,
  },
  {
    address: "stake1ux3yfujj6af3mhcrnwuauhg5ncgs3f35gck4lmvv3uetr4qxc5yw7",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 53107620,
    o_pool: "pool18qlwnav8ca79dqlw5grnt96f0pxe4awdyvrdpxde89ln7th9utp",
    o_loyalty: 3390996,
    amount: 3388443993,
    registered: "2023-03-20 16:56:26",
    active_epoch_no: 410,
    holder_detail:
      "http://cexplorer.io/stake/stake1ux3yfujj6af3mhcrnwuauhg5ncgs3f35gck4lmvv3uetr4qxc5yw7",
    payment_address:
      "addr1q8c4gfcswnwm8nel8cyqufcvx5eu64nxafr4trdpf6nqlsazgne9946nrh0s8xaemew3f8s3pznrg33dtlkcerejk82qd6sfk8",
    epochs_delegated: 121,
    Ada_delegated: 3388.443993,
    EKI_Rewards: "158,966.66",
    Rate: 0.021315,
  },
  {
    address: "stake1u87yhfwpk9rwulgx83u6d7z3efvfxyx2a5xufxe4pjapm0qv7g8mv",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 54480297,
    o_pool: "pool1yechqtexl9r7esg5scwynqalmjrpd5l69wkwrrw54y0x26eljpq",
    o_loyalty: 35446079,
    amount: 1707255312,
    registered: "2022-01-13 14:18:53",
    active_epoch_no: 407,
    holder_detail:
      "http://cexplorer.io/stake/stake1u87yhfwpk9rwulgx83u6d7z3efvfxyx2a5xufxe4pjapm0qv7g8mv",
    payment_address:
      "addr1qyykx8m6weyxmexq50cmmxad8w2pp0h0n2ejf8hanc4caylufwjurv2xae7sv0re5mu9rjjcjvgv4mgdcjdn2r96rk7q6sllgl",
    epochs_delegated: 124,
    Ada_delegated: 1707.255312,
    EKI_Rewards: "154,274.93",
    Rate: 0.011066,
  },
  {
    address: "stake1uyz93kuyt5kxa7xw4zrvhjgvevgjkyahzs9amnlae3sak3schgydt",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 54970956,
    o_pool: "",
    o_loyalty: "",
    amount: 187173259,
    registered: "2022-11-02 07:33:13",
    active_epoch_no: 406,
    holder_detail:
      "http://cexplorer.io/stake/stake1uyz93kuyt5kxa7xw4zrvhjgvevgjkyahzs9amnlae3sak3schgydt",
    payment_address:
      "addr1q820znf8j335z4dtqzr24kzwp2rjdu848w0yptcftc26gqcytrdcghfvdmuva2yxe0ysejc39vfmw9qtmh8lmnrpmdrqm4e5pa",
    epochs_delegated: 125,
    Ada_delegated: 187.173259,
    EKI_Rewards: "148,017.50",
    Rate: 0.001265,
  },
  {
    address: "stake1u9c3qhkr5xn3ghzh0vf96fazzqkeq3nhah983x8s4sxedvgks9l2j",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 63542723,
    o_pool: "",
    o_loyalty: "",
    amount: 16261251,
    registered: "2022-12-29 04:14:39",
    active_epoch_no: 386,
    holder_detail:
      "http://cexplorer.io/stake/stake1u9c3qhkr5xn3ghzh0vf96fazzqkeq3nhah983x8s4sxedvgks9l2j",
    payment_address:
      "addr1q8hyy3umkkpr0ave6slcgr54jpf8ljku5p4hyqrl6m4q7em3zp0v8gd8z3w9w7cjt5n6yypdjpr80mw20zv0ptqdj6csnsfqy0",
    epochs_delegated: 145,
    Ada_delegated: 16.261251,
    EKI_Rewards: "170,717.95",
    Rate: 0.000095,
  },
  {
    address: "stake1u8vnfv8ht6sjtv5z0xcumy2sdusfmj4xcsqwuf60djqgx0g9zx54k",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 63709827,
    o_pool: "",
    o_loyalty: "",
    amount: 10292659,
    registered: "2022-12-27 05:49:35",
    active_epoch_no: 386,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8vnfv8ht6sjtv5z0xcumy2sdusfmj4xcsqwuf60djqgx0g9zx54k",
    payment_address:
      "addr1q89yuxfnlw2xchxu83j5uudr4f5grnr4jkpzwkelaqj429xexjc0wh4pykegy7d3ekg4qmeqnh92d3qqacn57myqsv7sh3ktac",
    epochs_delegated: 145,
    Ada_delegated: 10.292659,
    EKI_Rewards: "170,688.76",
    Rate: 0.00006,
  },
  {
    address: "stake1u8x0e6tdkkexclnspqjd2smx2vr4gae0zyhjlr3jgu470dcsdu8kf",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 68539361,
    o_pool: "",
    o_loyalty: "",
    amount: 2485284907,
    registered: "2022-11-01 08:15:31",
    active_epoch_no: 374,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8x0e6tdkkexclnspqjd2smx2vr4gae0zyhjlr3jgu470dcsdu8kf",
    payment_address:
      "addr1qynj0s307f4agzm62m76qehg4u5tmdfaq2r5vdzjeylzny7vln5kmddjd3l8qzpy64pkv5c823mj7yf0978ry3etu7msprc6gl",
    epochs_delegated: 157,
    Ada_delegated: 2485.284907,
    EKI_Rewards: "196,914.99",
    Rate: 0.012621,
  },
  {
    address: "stake1uy0u9t80ga0l0uzcwqrrtwu9t06ke52960y0rpdwmlh0rrqns554w",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 69102472,
    o_pool: "",
    o_loyalty: "",
    amount: 27247921980,
    registered: "2022-10-25 19:52:10",
    active_epoch_no: 373,
    holder_detail:
      "http://cexplorer.io/stake/stake1uy0u9t80ga0l0uzcwqrrtwu9t06ke52960y0rpdwmlh0rrqns554w",
    payment_address:
      "addr1qxsaggs6gjcyh5wt2xjckc03pg84zvrlq9gqtdhcmv8p9zglc2kw736l7lc9suqxxkac2kl4dng5t57g7xz6ahlw7xxqw8qerl",
    epochs_delegated: 158,
    Ada_delegated: 27247.92198,
    EKI_Rewards: "319,198.25",
    Rate: 0.085364,
  },
  {
    address: "stake1u8slxa92q668jpge5prjkrsa3mj78kj4kfq7v42j7jkpv9sx8hnhz",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 69991962,
    o_pool: "",
    o_loyalty: "",
    amount: 263299133,
    registered: "2022-10-15 12:47:20",
    active_epoch_no: 371,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8slxa92q668jpge5prjkrsa3mj78kj4kfq7v42j7jkpv9sx8hnhz",
    payment_address:
      "addr1qxh7c47skeeaqjweakww80a0etcah408d7gdsjp83asm2ylp7d625p450yz3ngz89v8pmrh9u0d9tvjpue249a9vzctqwz3dad",
    epochs_delegated: 160,
    Ada_delegated: 263.299133,
    EKI_Rewards: "189,578.39",
    Rate: 0.001389,
  },
  {
    address: "stake1uyyyt28juym3qk258nyvut8gjumkx5n7xv7s9yz5h2qj3gqg0vyhw",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 71106262,
    o_pool: "pool1ekhy5xsgjaq38em75vevk8df0k0rljju77tljw288ys5kumqce5",
    o_loyalty: 855723,
    amount: 2072532714,
    registered: "2022-10-02 15:15:40",
    active_epoch_no: 368,
    holder_detail:
      "http://cexplorer.io/stake/stake1uyyyt28juym3qk258nyvut8gjumkx5n7xv7s9yz5h2qj3gqg0vyhw",
    payment_address:
      "addr1qxe254cy2elgnezmek5w42jw6u0f6dxr903p523euvqcglsggk509cfhzpv4g0xgeckw39ehvdf8uveaq2g9fw5p9zsq3aca6h",
    epochs_delegated: 163,
    Ada_delegated: 2072.532714,
    EKI_Rewards: "201,957.24",
    Rate: 0.010262,
  },
  {
    address: "stake1uxv4tm2tcsdtvem99hwd72ayzrzsg7lqkx0rqc28dqavs2cl0helj",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 71511614,
    o_pool: "pool1jk25l2pejpdzq8vdjlxrr05th49v9tgd78fqrtxvuw3rumpfc6t",
    o_loyalty: 21961667,
    amount: 7058809544,
    registered: "2021-08-16 08:14:27",
    active_epoch_no: 368,
    holder_detail:
      "http://cexplorer.io/stake/stake1uxv4tm2tcsdtvem99hwd72ayzrzsg7lqkx0rqc28dqavs2cl0helj",
    payment_address:
      "addr1q92hc7v02cq82gt79vn3ujl5jyeu0rl3u9pyf8zzmwnv8d5e2hk5h3q6kenk2twumu46gyx9q3a7pvv7xps5w6p6eq4s59kq32",
    epochs_delegated: 163,
    Ada_delegated: 7058.809544,
    EKI_Rewards: "226,343.59",
    Rate: 0.031186,
  },
  {
    address: "stake1uy2nddpplhrxw5adf0lrhvvauf5ntjgdsyrcnkfhzw4644qprfglr",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 85574086,
    o_pool: "pool1n5shd9xdt4s2gm27fxcnuejaqhhmpepn6chw2c82kqnuzdtpsem",
    o_loyalty: 27092243,
    amount: 9814597651,
    registered: "2021-01-29 04:22:14",
    active_epoch_no: 335,
    holder_detail:
      "http://cexplorer.io/stake/stake1uy2nddpplhrxw5adf0lrhvvauf5ntjgdsyrcnkfhzw4644qprfglr",
    payment_address:
      "addr1qyejwvlyru5u3wc6k6x977zq3x30svzn4qmj0cadxkhwwds4x66zrlwxvaf66jl78wcemcnfxhysmqg838vnwyat4t2q5vf2tt",
    epochs_delegated: 196,
    Ada_delegated: 9814.597651,
    EKI_Rewards: "278,656.25",
    Rate: 0.035221,
  },
  {
    address: "stake1u8jqcz93nv24ujf7cfwweyf6axx53tz0sn09nmuhx3k0f6sltz4mh",
    n_pool: "pool1jqssxka8hu94aj6f4w3s8l5m6juqmx0hk3ges48jfac6zngmkh8",
    n_loyalty: 86016694,
    o_pool: "pool1n5shd9xdt4s2gm27fxcnuejaqhhmpepn6chw2c82kqnuzdtpsem",
    o_loyalty: 23411919,
    amount: 481763457,
    registered: "2021-07-16 02:09:49",
    active_epoch_no: 334,
    holder_detail:
      "http://cexplorer.io/stake/stake1u8jqcz93nv24ujf7cfwweyf6axx53tz0sn09nmuhx3k0f6sltz4mh",
    payment_address:
      "addr1q8ez5xfg5464fl0thg7d6uacy7lpxvf3zs8yn8vttj7wx50ypsytrxc4teynasjuajgn46vdfzkylpx7t8hewdrv7n4qsm0ckg",
    epochs_delegated: 197,
    Ada_delegated: 481.763457,
    EKI_Rewards: "234,189.05",
    Rate: 0.002057,
  },
];
